import Page from "@insite/mobius/Page/";
import merge from "lodash/merge";
import { css } from "styled-components";

export const clearfixStyles = () => {
    return css`
        &::before,
        &::after {
            content: "";
            display: table;
        }

        &::after {
            clear: both;
        }
    `;
};

merge(Page.defaultProps, {
    padding: 0,
    fullWidth: [true, true, true, true, true],
    css: css`
        /* Chrome 87 - Fix margin issues - Temporary fix ? */
        ${clearfixStyles()}
    `,
});
